import qs from 'qs';
import {MainRequest} from './common';
import Storage from 'Services/Storage';
import lodash from 'lodash-es';

export default function login(loginName: string, password: string) {
    loginName = lodash.cloneDeep(loginName);
    password = lodash.cloneDeep(password);

    return MainRequest.post<SuccessData<string>>(
        '/login',
        qs.stringify({
            loginName,
            password,
        }),
    ).then(async res => {
        const token = res.data.data;

        Storage.set('loginName', loginName);
        Storage.set('token', token);
    });
}

export interface UserInfo {
    no?: string; // 工号
    name?: string; // 姓名
    email?: string; // 邮箱
    phone?: string; // 电话号
    mobile?: string; // 手机
    photo?: string; // 头像/照片
}

/**
 * 获取用户信息
 */
export async function userinfo(): Promise<UserInfo> {
    return {no: '123456', name: '孟浩'};
    // return MainRequest.get<SuccessData<UserInfo>>(
    //     '/a/api/authorityRest/userinfo',
    // ).then(res => res.data.data);
}

/**
 * 退出登录
 */
export function logout() {
    Storage.clear();
}

interface RoleItem {
    roleId: string;
    roleName: string;
    currentRole: BooleanValue;
}

/**
 * 获取登录用户所有角色
 */
export function getAllRoleByUser() {
    return MainRequest.get<SuccessData<RoleItem[]>>(
        '/role/getUserRoleList',
    ).then(res => res.data.data);
}

/**
 * 更改当前角色
 */
export function changeCurrentUserRole(roleId: string) {
    return MainRequest.post('/role/changeCurrentUserRole', {roleId});
}
